<block-ui>
  @if (!isSignDocument) {
    <app-nav [logo]="logo"></app-nav>
  }
  <router-outlet></router-outlet>
  @if (!isSignDocument) {
    <app-footer></app-footer>
  }
</block-ui>